module.exports = __webpack_public_path__ + "img/table_service.87894a02.svg";